module.exports = __webpack_public_path__ + "assets/images/img/Matchmaking-02.0a76e7477df7ec9550b412eefaf3e64a.png";